/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_Open_TaskInputs */

const cs_viewings_open_task = /** @type {(inputs: Viewings_Open_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít úkol protokolu`)
};

const en_viewings_open_task = /** @type {(inputs: Viewings_Open_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open protocol task`)
};

/**
* | output |
* | --- |
* | "Open protocol task" |
*
* @param {Viewings_Open_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_open_task = /** @type {((inputs?: Viewings_Open_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Open_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_open_task(inputs)
	return cs_viewings_open_task(inputs)
});